import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { TagAutocomplete } from '@/features/tags/components/TagAutocomplete'
import { useGenerationFormStore } from '../store'

export function PromptInput() {
  const { t } = useTranslation()
  const positivePrompt = useGenerationFormStore((s) => s.positivePrompt)
  const negativePrompt = useGenerationFormStore((s) => s.negativePrompt)
  const setPositivePrompt = useGenerationFormStore((s) => s.setPositivePrompt)
  const setNegativePrompt = useGenerationFormStore((s) => s.setNegativePrompt)
  const isGenerating = useGenerationFormStore((s) => s.isGenerating)

  const handleTagSelect = useCallback(
    (tag: string) => {
      const separator = positivePrompt.trim() ? ', ' : ''
      setPositivePrompt(positivePrompt.trim() + separator + tag)
    },
    [positivePrompt, setPositivePrompt],
  )

  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-col gap-1">
        <label
          htmlFor="positive-prompt"
          className="text-xs font-medium text-tg-hint"
        >
          {t('generate.prompt')}
        </label>
        <textarea
          id="positive-prompt"
          value={positivePrompt}
          onChange={(e) => { setPositivePrompt(e.target.value) }}
          disabled={isGenerating}
          placeholder={t('generate.promptPlaceholder')}
          rows={3}
          className="w-full resize-none rounded-lg border border-tg-hint/20 px-3 py-2 text-sm outline-none input-focus bg-tg-secondary text-tg-text"
        />
        {!isGenerating && (
          <TagAutocomplete
            onTagSelect={handleTagSelect}
            placeholder={t('generate.tagSearch')}
            className="mt-1"
          />
        )}
      </div>

      <div className="flex flex-col gap-1">
        <label
          htmlFor="negative-prompt"
          className="text-xs font-medium text-tg-hint"
        >
          {t('generate.negativePrompt')}
        </label>
        <textarea
          id="negative-prompt"
          value={negativePrompt}
          onChange={(e) => { setNegativePrompt(e.target.value) }}
          disabled={isGenerating}
          placeholder={t('generate.negativePromptPlaceholder')}
          rows={2}
          className="w-full resize-none rounded-lg border border-tg-hint/20 px-3 py-2 text-sm outline-none input-focus bg-tg-secondary text-tg-text"
        />
      </div>
    </div>
  )
}
